import FollowBtn from 'components/Common/ActionButton/FollowBtn';
import { IMAGE_PATHS } from 'constants/imagePaths';
import useTranslate from 'hooks/useTranslate';
import React, { useEffect, useState } from 'react';
import { Image, Stack } from 'react-bootstrap';

const HashtagTile: React.FC<any> = ({ res, goToDetailPage }) => {
	const { translate } = useTranslate();
	const [totalFollowers, setTotalFollowers] = useState(0);

	useEffect(() => {
		setTotalFollowers(res?.totalFollowers || 0);
	}, [res?.totalFollowers]);

	return (
		<Stack className="business-box">
			<div className="business-box-logo" onClick={() => goToDetailPage(res?.id)}>
				<Image src={IMAGE_PATHS.Hashtag} alt="logo" className="w-100 h-100" loading="lazy" />
			</div>
			<div className="">
				<h6 className="fw-bold mb-1" onClick={() => goToDetailPage(res?.id)}>
					#{res.name}
				</h6>
				<p className="business-type mb-0">
					{totalFollowers} {translate('Common.followers')}{' '}
				</p>
			</div>
			<FollowBtn
				resData={res}
				isFollowed={res?.isFollowed}
				id={res?.id}
				follow={'hash'}
				show={true}
				setTotalFollowers={setTotalFollowers}
			/>
		</Stack>
	);
};

export default HashtagTile;
